module.exports = __webpack_public_path__ + "static/img/wxcode.83dad2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wxcode.png
// module id = sGg/
// module chunks = 46